import { HarmonyPackageBoardSchema } from '@rhythmic/types'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'

export const HARMONY_PACKAGE_BOARD_TABLE = '"public"."harmonyPackageBoards"'

export const HarmonyPackageBoardConfig: CollectionBuildRequestConfig = {
  collectionType: 'electric',
  table: HARMONY_PACKAGE_BOARD_TABLE,
  partitionKey: 'package_id',
  key: 'id',
  apiEndpoint: '/api/harmony-package-boards',
  where: {},
  schema: HarmonyPackageBoardSchema,
}
